(function () {
  // 1024px より大きい場合は何もしない
  if (window.innerWidth > 1024) return;

  const infoWrapper = document.querySelector(".product__info-wrapper");
  if (!infoWrapper) return;

  // 初期化時に高さを1回だけ取得
  const slotHeight = infoWrapper.offsetHeight;

  function createSlot(className) {
    const slot = document.createElement("div");
    slot.classList.add(className);
    slot.style.cssText = "display: block !important; height: " + slotHeight + "px;";
    return slot;
  }

  // --- default slot 作成 ---
  // .product__info-wrapper の元の位置（親要素内の同位置）に挿入
  const defaultSlot = createSlot("js_mobileProductInfo_slot_default");
  infoWrapper.parentNode.insertBefore(defaultSlot, infoWrapper);

  // --- top slot 作成 ---
  const peiWrapper = document.querySelector(".pei-wrapper");
  let topSlot = null;
  if (peiWrapper) {
    topSlot = createSlot("js_mobileProductInfo_slot_top");
    peiWrapper.parentNode.insertBefore(topSlot, peiWrapper);
  }

  // --- bottom slot 作成 ---
  const detailEx02 = document.querySelector(".slingbelt_section_detail_ex02");
  let bottomSlot = null;
  if (detailEx02) {
    bottomSlot = createSlot("js_mobileProductInfo_slot_bottom");
    detailEx02.parentNode.insertBefore(bottomSlot, detailEx02.nextSibling);
  }

  // --- 初期配置 ---
  // top slot があれば top へ、なければ default へ
  if (topSlot) {
    topSlot.appendChild(infoWrapper);
  } else {
    defaultSlot.appendChild(infoWrapper);
  }

  // --- top slot 表示切り替え対象要素 ---
  const topHideSelectors = [".item_comment", ".tenkenbtn", ".share-button"];

  function setTopSlotVisibility(isTop) {
    topHideSelectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        el.style.display = isTop ? "none" : "";
      });
    });
  }

  // --- スクロール処理 ---
  let currentSlot = topSlot || defaultSlot;

  // 初期配置が top の場合は非表示にして高さを再計算
  if (currentSlot === topSlot) {
    setTopSlotVisibility(true);
    topSlot.style.height = infoWrapper.offsetHeight + "px";
  }

  function moveToSlot(targetSlot) {
    if (currentSlot === targetSlot) return;
    targetSlot.appendChild(infoWrapper);
    currentSlot = targetSlot;
    setTopSlotVisibility(targetSlot === topSlot);
    // top slot に配置された時は高さを再計算
    if (targetSlot === topSlot) {
      topSlot.style.height = infoWrapper.offsetHeight + "px";
    }
  }

  window.addEventListener(
    "scroll",
    function () {
      const scrollY = window.scrollY || window.pageYOffset;

      // 閾値B
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      const thresholdB = maxScroll / 3;

      // 閾値A（.pei-wrapper が存在する場合のみ）
      let thresholdA = null;
      if (peiWrapper) {
        const peiRect = peiWrapper.getBoundingClientRect();
        const peiTop = peiRect.top + scrollY;
        thresholdA = peiTop + peiWrapper.offsetHeight * 0.2;
      }

      // 優先順位: bottom > default > top
      if (bottomSlot && scrollY > thresholdB) {
        moveToSlot(bottomSlot);
      } else if (topSlot && (thresholdA === null || scrollY <= thresholdA)) {
        moveToSlot(topSlot);
      } else {
        moveToSlot(defaultSlot);
      }
    },
    { passive: true },
  );
})();
